module.exports = __webpack_public_path__ + "static/media/2.b6c9938d.png";